<template>
    <div class="row ms-3 me-3 pb-3 pt-3">
        <div class="col-5 align-self-center" >
            <div >
                <div class="fw-bold text-uppercase">{{ this.get_event_start_date(this.$root.event_list[this.event_id]['start_event']) }}</div>
                <div class="fw-bold text-uppercase">{{ this.$root.event_list[this.event_id].name }}</div>
                <div>({{this.cartItem.name}})</div>
                <div v-if= "typeof this.$root.seating_place_info[this.idx] !== 'undefined'">
                    <div class="big_number">Section <span class="black color-secondary">{{this.$root.seating_place_info[this.idx]['section'] }}</span>, Rangée <span class="black color-secondary">{{ this.$root.seating_place_info[this.idx]['row'] }}</span>, Siège <span class="black color-secondary">{{ this.$root.seating_place_info[this.idx]['seat'] }}</span></div>
                </div>
            </div>
        </div>
        <div class="col-2 align-self-center text-center">{{this.price_format}}</div>
        <div class="col-2 align-self-center text-center">{{this.quantity}}</div>
        <div class="col-2 align-self-center text-center">{{this.subtotal}}</div>
        <div class="col-1 align-self-center text-end"><button type="button" @click="deleteItem" class="btn_x_delete"><i class="far fa-times"></i></button></div>
    </div>
</template>

<script>
import RegularProduct from "../products/RegularProduct";
import {formatCurrency, formatTimeStamp} from "../../helpers/kiosk-helpers";

export default {
    name: "CartItem",

    data() {
        return {
            quantity: 0,
            type: '', // regular || composition
            price: 0,
            price_format:0,
            subtotal: 0,
            event_id: null,
        }
    },
/*
    place(value){
        this.change_time(value.time_end);
    },*/

    created() {
        this.init();
    },
    methods: {
        init() {
            this.event_id = this.cartItem.features['FEATURE_EVENT_INFOS']['FEATURE_EVENT_UID'];
            this.price = this.cartItem['prices_informations']['default_price'];
            this.price_format = formatCurrency(this.cartItem['prices_informations']['default_price']);
            this.quantity = 1;
            this.subtotal = formatCurrency(this.price * this.quantity);
            let databaseUID = null;
            if (typeof this.place !== 'undefined') {
                databaseUID = this.place['databaseUID'];

                //this.change_time(this.place['time_end']);
            }
        },
        deleteItem()
        {
            this.$root.has_call_ajax.push('delete-summary-item');
            this.$root.deleteCartItemByIdx(this.idx)
                .then(() => {
                    this.$root.refreshCart()
                        .then(() => {
                            this.$root.has_call_ajax = this.$root.arrayRemove(this.$root.has_call_ajax,'delete-summary-item');
                        })
                        .catch(error => {
                            this.$root.addErrors('a-116',null,String(error));
                        });
                })
                .catch(error => {
                    this.$root.addErrors('a-116-2',null,String(error));
                });
        },
        get_event_start_date(timestamp)
        {
            return formatTimeStamp(timestamp);
        },

    },



    components: {
        'regular-product-component': RegularProduct,
    },

    props: {
        cartItem: Object,
        idx: String,
        place: Array,
    }
}
</script>

<style scoped>

</style>
